import { Box } from '@kluein/klue-ui';

import { SnowplowProvider, SnowplowPage } from 'lib/analytics/snowplow/react';

import AskKluePage from './AskKluePage';

/**
 * Embedded version of Ask Klue page for third-party apps
 * Renders without navigation UI but with authentication checks
 *
 * Authentication is handled by:
 * 1. App-level auth from useAuth context
 * 2. AskKluePage component's internal permission check
 */
export default function AskKlueEmbed() {
  return (
    <SnowplowProvider>
      <SnowplowPage isContextReady>
        <Box fill overflow="auto" style={{ minHeight: '100vh' }}>
          <AskKluePage isEmbedded />
        </Box>
      </SnowplowPage>
    </SnowplowProvider>
  );
}
